import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

/**
 * URL Param Controller
 * 
 * Updates URL query parameters based on input value on blur or Enter key press.
 * 
 * Usage:
 *   <input type='text' 
 *     name='search'
 *     data-controller="url-param"
 *     data-url-param-url-value="/search"
 *     data-action="blur->url-param#update keydown->url-param#onKeydown"
 *   />
 * 
 * Values:
 *   - url: The base URL to navigate to with the input value as a query parameter
 *   - turboFrame: optional Turbo frame id; when present, the update targets that
 *     frame (async filtering) instead of triggering a full page navigation
 */
export default class extends Controller {
  static values = { url: String, turboFrame: String }

  update() {
    if (!this.hasUrlValue || !this.urlValue) return

    const url = new URL(this.urlValue, window.location.origin)
    const paramName = this.element.name
    const value = this.element.value.trim()

    if (value) {
      url.searchParams.set(paramName, value)
    } else {
      url.searchParams.delete(paramName)
    }

    if (this.hasTurboFrameValue && this.turboFrameValue) {
      Turbo.visit(url.toString(), { frame: this.turboFrameValue, action: "advance" })
    } else {
      window.location.href = url.toString()
    }
  }

  onKeydown(event) {
    if (event.key === "Enter") {
      event.preventDefault()
      this.update()
    }
  }
}
